import { render } from "./MasternodeReward.vue?vue&type=template&id=37ec860e"
import script from "./MasternodeReward.vue?vue&type=script&setup=true&lang=js"
export * from "./MasternodeReward.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/masternode/MasternodeReward.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37ec860e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37ec860e', __exports__)) {
    api.reload('37ec860e', __exports__)
  }
  
  module.hot.accept("./MasternodeReward.vue?vue&type=template&id=37ec860e", () => {
    api.rerender('37ec860e', render)
  })

}


export default __exports__